import React from "react";
import { Loadable } from "components/support";
import Paper from "material-ui-next/Paper";
import "chartkick";
import { LineChart } from "react-chartkick";

import style from "./style";

const formatter = format => ({ from, to, value }) => {
  const fromLabel = from.format(format);
  const toLabel = to.format(format);

  const label =
    fromLabel === toLabel ? `${fromLabel} -` : `${fromLabel} - ${toLabel}`;

  return [label, value.div(100).toFixed(2)];
};

const formats = {
  hours: "HH:mm",
  day: "DD/MM",
  week: "DD/MM",
  month: "MM/YY",
  year: "YYYY"
};

const HistoryGraph = ({ className, viewModel }) => {
  const { loading, results, format } = viewModel;
  const graphCosts = results.map(formatter(formats[format]));

  return (
    <Loadable loading={loading} className={className}>
      <Paper elevation={1}>
        <div className="graph-container">
          <LineChart
            xtitle="Período"
            ytitle="Preço de Compra (R$)"
            data={[{ name: "Preço de Compra (R$)", data: graphCosts }]}
          />
        </div>
      </Paper>
    </Loadable>
  );
};

export default style(HistoryGraph);



// WEBPACK FOOTER //
// ./src/components/app/history/stock-entry-reports/history-graph/view.jsx